import crawlApi, { type CrawlRequestBody } from './crawlApi';

export type StartCrawlResponse = {
  code: number;
  data: string | { job_page: string };
};

export type DomainCrawlSettingsData = {
  domain_slug: string;
  settings: Record<string, unknown> | null;
};

export type DomainCrawlSettingsResponse = {
  code: number;
  msg: string;
  data: DomainCrawlSettingsData;
};

export type UpdateDomainCrawlSettingsRequest = {
  domain_slug: string;
  settings: Record<string, unknown> | null;
};

const mainCrawlApi = crawlApi.injectEndpoints({
  endpoints: build => ({
    startCrawling: build.mutation<StartCrawlResponse, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: '/khazesh/v3/crawl/',
        method: 'POST',
        body: body
      })
    }),

    stopCrawling: build.mutation<unknown, CrawlRequestBody>({
      query: (body: CrawlRequestBody) => ({
        url: '/khazesh/v3/crawl/stop',
        method: 'POST',
        body: body
      })
    }),
    getDomainCrawlSettings: build.query<
      DomainCrawlSettingsResponse,
      string
    >({
      query: domain_slug => ({
        url: '/khazesh/v3/crawl/settings',
        method: 'GET',
        params: { domain_slug }
      })
    }),
    updateDomainCrawlSettings: build.mutation<
      DomainCrawlSettingsResponse,
      UpdateDomainCrawlSettingsRequest
    >({
      query: body => ({
        url: '/khazesh/v3/crawl/settings',
        method: 'POST',
        body
      })
    })
  }),
  overrideExisting: false
});

export const {
  useStartCrawlingMutation,
  useStopCrawlingMutation,
  useGetDomainCrawlSettingsQuery,
  useLazyGetDomainCrawlSettingsQuery,
  useUpdateDomainCrawlSettingsMutation
} = mainCrawlApi;
export default mainCrawlApi;
